import { compactBindingLabel as sharedCompactBindingLabel } from './bindingQuality';

export const ACTION_LANES = [
  { value: 'gm_correction', label: 'GM correction' },
  { value: 'cpq_peoplesoft_adjustment', label: 'CPQ / PeopleSoft' },
  { value: 'none', label: 'Audit only' },
];

export const ACTION_MUTATIONS = [
  { value: 'add', label: 'Add' },
  { value: 'remove', label: 'Remove' },
  { value: 'adjust', label: 'Adjust' },
  { value: 'replace', label: 'Replace' },
  { value: 'none', label: 'Evidence' },
];

export const ACTION_DOMAINS = [
  { value: 'gm_file_correction', label: 'GM file correction' },
  { value: 'cpq_peoplesoft_followup', label: 'CPQ / PeopleSoft follow-up' },
  { value: 'evidence_binding', label: 'Evidence binding' },
  { value: 'manual_review', label: 'Manual review' },
];

export const laneLabel = (lane) => (
  ACTION_LANES.find((option) => option.value === lane)?.label || 'Audit only'
);

export const mutationLabel = (mutation) => (
  ACTION_MUTATIONS.find((option) => option.value === mutation)?.label || mutation || 'Evidence'
);

export const domainLabel = (domain) => (
  ACTION_DOMAINS.find((option) => option.value === domain)?.label || 'Manual review'
);

export const mutationColor = (mutation) => {
  if (mutation === 'add') return 'success';
  if (mutation === 'remove') return 'error';
  if (mutation === 'adjust' || mutation === 'replace') return 'warning';
  return 'default';
};

export const EXPORT_LIFECYCLE_OPTIONS = [
  { value: 'lifecycle:not_exported', status: 'not_exported', label: 'Not exported' },
  { value: 'lifecycle:changed_after_export', status: 'changed_after_export', label: 'Changed after export' },
  { value: 'lifecycle:exported', status: 'exported', label: 'Exported' },
  { value: 'lifecycle:re_exported', status: 're_exported', label: 'Re-exported' },
];

export const exportLifecycleLabel = (row = {}) => {
  const status = row.exportLifecycleStatus || (row.status === 'exported' ? 'exported' : 'not_exported');
  return EXPORT_LIFECYCLE_OPTIONS.find((option) => option.status === status)?.label || 'Not exported';
};

export const exportLifecycleColor = (row = {}) => {
  const status = row.exportLifecycleStatus || (row.status === 'exported' ? 'exported' : 'not_exported');
  if (status === 'changed_after_export') return 'warning';
  if (status === 'exported' || status === 're_exported') return 'success';
  return 'default';
};

export const compactBindingLabel = (row) => sharedCompactBindingLabel(row);
